module.exports = __webpack_public_path__ + "img/NewBg.ace44948.jpg";